import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SegmentPreviewContactResponse } from '../../../models/segment.model';

@Component({
  selector: 'app-segment-preview-panel',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './segment-preview-panel.component.html',
})
export class SegmentPreviewPanelComponent {

  @Input() type: 'STATIC' | 'DYNAMIC' | null = null;

  @Input() hasRules: boolean = false;
  @Input() showFilters: boolean = false;
  @Input() isLoadingPreview: boolean = false;
  @Input() totalContactosPreview: number = 0;
  @Input() porcentajePreview: number = 0;
  @Input() totalContactosCrm: number = 0;
  @Input() contactosPreview: SegmentPreviewContactResponse[] = [];
  @Input() previewPage: number = 0;
  @Input() previewTotalPages: number = 0;

  @Output() pageChange = new EventEmitter<number>();

  previousPage(): void {
    if (this.previewPage > 0) this.pageChange.emit(this.previewPage - 1);
  }

  nextPage(): void {
    if (this.previewPage < this.previewTotalPages - 1) this.pageChange.emit(this.previewPage + 1);
  }

}
